module.exports = (function(){
  /*
   * Generated by PEG.js 0.7.0.
   *
   * http://pegjs.majda.cz/
   */
  
  function quote(s) {
    /*
     * ECMA-262, 5th ed., 7.8.4: All characters may appear literally in a
     * string literal except for the closing quote character, backslash,
     * carriage return, line separator, paragraph separator, and line feed.
     * Any character may appear in the form of an escape sequence.
     *
     * For portability, we also escape escape all control and non-ASCII
     * characters. Note that "\0" and "\v" escape sequences are not used
     * because JSHint does not like the first and IE the second.
     */
     return '"' + s
      .replace(/\\/g, '\\\\')  // backslash
      .replace(/"/g, '\\"')    // closing quote character
      .replace(/\x08/g, '\\b') // backspace
      .replace(/\t/g, '\\t')   // horizontal tab
      .replace(/\n/g, '\\n')   // line feed
      .replace(/\f/g, '\\f')   // form feed
      .replace(/\r/g, '\\r')   // carriage return
      .replace(/[\x00-\x07\x0B\x0E-\x1F\x80-\uFFFF]/g, escape)
      + '"';
  }
  
  var result = {
    /*
     * Parses the input with a generated parser. If the parsing is successfull,
     * returns a value explicitly or implicitly specified by the grammar from
     * which the parser was generated (see |PEG.buildParser|). If the parsing is
     * unsuccessful, throws |PEG.parser.SyntaxError| describing the error.
     */
    parse: function(input, startRule) {
      var parseFunctions = {
        "timespec": parse_timespec,
        "spec_base": parse_spec_base,
        "time_base": parse_time_base,
        "hr24clock_hr_min": parse_hr24clock_hr_min,
        "time_hour": parse_time_hour,
        "time_hour_min": parse_time_hour_min,
        "am_pm": parse_am_pm,
        "timezone_name": parse_timezone_name,
        "date": parse_date,
        "concatenated_date": parse_concatenated_date,
        "month_name": parse_month_name,
        "year_number": parse_year_number,
        "day_of_week": parse_day_of_week,
        "inc_or_dec": parse_inc_or_dec,
        "increment": parse_increment,
        "decrement": parse_decrement,
        "inc_dec_period": parse_inc_dec_period,
        "int1_2digit": parse_int1_2digit,
        "int2_or_4digit": parse_int2_or_4digit,
        "str5_8digit": parse_str5_8digit,
        "integer": parse_integer,
        "_": parse__
      };
      
      if (startRule !== undefined) {
        if (parseFunctions[startRule] === undefined) {
          throw new Error("Invalid rule name: " + quote(startRule) + ".");
        }
      } else {
        startRule = "timespec";
      }
      
      var pos = 0;
      var reportFailures = 0;
      var rightmostFailuresPos = 0;
      var rightmostFailuresExpected = [];
      
      function padLeft(input, padding, length) {
        var result = input;
        
        var padLength = length - input.length;
        for (var i = 0; i < padLength; i++) {
          result = padding + result;
        }
        
        return result;
      }
      
      function escape(ch) {
        var charCode = ch.charCodeAt(0);
        var escapeChar;
        var length;
        
        if (charCode <= 0xFF) {
          escapeChar = 'x';
          length = 2;
        } else {
          escapeChar = 'u';
          length = 4;
        }
        
        return '\\' + escapeChar + padLeft(charCode.toString(16).toUpperCase(), '0', length);
      }
      
      function matchFailed(failure) {
        if (pos < rightmostFailuresPos) {
          return;
        }
        
        if (pos > rightmostFailuresPos) {
          rightmostFailuresPos = pos;
          rightmostFailuresExpected = [];
        }
        
        rightmostFailuresExpected.push(failure);
      }
      
      function parse_timespec() {
        var result0, result1, result2;
        var pos0, pos1, pos2;
        
        pos0 = pos;
        pos1 = pos;
        result0 = parse_spec_base();
        if (result0 !== null) {
          pos2 = pos;
          result1 = parse__();
          if (result1 !== null) {
            result2 = parse_inc_or_dec();
            if (result2 !== null) {
              result1 = [result1, result2];
            } else {
              result1 = null;
              pos = pos2;
            }
          } else {
            result1 = null;
            pos = pos2;
          }
          result1 = result1 !== null ? result1 : "";
          if (result1 !== null) {
            result0 = [result0, result1];
          } else {
            result0 = null;
            pos = pos1;
          }
        } else {
          result0 = null;
          pos = pos1;
        }
        if (result0 !== null) {
          result0 = (function(offset, base, tail) {
            if (typeof(tail) === 'object') {
              var count = tail[1]['count'];
              var amount = tail[1]['amount'];
        
              base.setFullYear(base.getFullYear() + (amount.y * count));
              base.setMonth(base.getMonth() + (amount.m * count));
              base.setDate(base.getDate() + (amount.d * count));
              base.setHours(base.getHours() + (amount.h * count));
              base.setMinutes(base.getMinutes() + (amount.i * count));
            }
        
            return base;
          })(pos0, result0[0], result0[1]);
        }
        if (result0 === null) {
          pos = pos0;
        }
        return result0;
      }
      
      function parse_spec_base() {
        var result0, result1, result2, result3;
        var pos0, pos1, pos2, pos3;
        
        result0 = parse_date();
        if (result0 === null) {
          pos0 = pos;
          pos1 = pos;
          result0 = parse_time_base();
          if (result0 !== null) {
            pos2 = pos;
            pos3 = pos;
            result1 = parse__();
            if (result1 !== null) {
              result2 = parse_timezone_name();
              if (result2 !== null) {
                result1 = [result1, result2];
              } else {
                result1 = null;
                pos = pos3;
              }
            } else {
              result1 = null;
              pos = pos3;
            }
            result1 = result1 !== null ? result1 : "";
            if (result1 !== null) {
              pos3 = pos;
              result2 = parse__();
              if (result2 !== null) {
                result3 = parse_date();
                if (result3 !== null) {
                  result2 = [result2, result3];
                } else {
                  result2 = null;
                  pos = pos3;
                }
              } else {
                result2 = null;
                pos = pos3;
              }
              result2 = result2 !== null ? result2 : "";
              if (result2 !== null) {
                result1 = [result1, result2];
              } else {
                result1 = null;
                pos = pos2;
              }
            } else {
              result1 = null;
              pos = pos2;
            }
            result1 = result1 !== null ? result1 : "";
            if (result1 !== null) {
              result0 = [result0, result1];
            } else {
              result0 = null;
              pos = pos1;
            }
          } else {
            result0 = null;
            pos = pos1;
          }
          if (result0 !== null) {
            result0 = (function(offset, t, tail) {
              var utc = false;
              var date = null;
              if (typeof(tail) === 'object') {
                if (typeof(tail[0]) === 'object') {
                  utc = true;
                }
                if (typeof(tail[1]) === 'object') {
                  date = tail[1][1];
                }
              }
          
              if (utc) {
                t = new Date(Date.UTC(
                  t.getFullYear(),
                  t.getMonth(),
                  t.getDate(),
                  t.getHours(),
                  t.getMinutes(),
                  t.getSeconds(),
                  t.getMilliseconds()));
              }
          
              if (date) {
                if (utc) {
                  t.setUTCFullYear(date.getFullYear());
                  t.setUTCMonth(date.getMonth());
                  t.setUTCDate(date.getDate());
                }
                else {
                  t.setFullYear(date.getFullYear());
                  t.setMonth(date.getMonth());
                  t.setDate(date.getDate());
                }
              }
              else {
                /* If no date is specified and the time has already passed, follow
                 * the behavior of 'at' and pick the same time tomorrow.
                 */
                var now = new Date();
                if (t < now) {
                  t.setDate(t.getDate() + 1);
                }
              }
          
              return t;
            })(pos0, result0[0], result0[1]);
          }
          if (result0 === null) {
            pos = pos0;
          }
          if (result0 === null) {
            pos0 = pos;
            if (input.substr(pos, 3).toLowerCase() === "now") {
              result0 = input.substr(pos, 3);
              pos += 3;
            } else {
              result0 = null;
              if (reportFailures === 0) {
                matchFailed("\"NOW\"");
              }
            }
            if (result0 !== null) {
              result0 = (function(offset) {
                return new Date();
              })(pos0);
            }
            if (result0 === null) {
              pos = pos0;
            }
          }
        }
        return result0;
      }
      
      function parse_time_base() {
        var result0, result1, result2;
        var pos0, pos1, pos2;
        
        result0 = parse_hr24clock_hr_min();
        if (result0 === null) {
          pos0 = pos;
          pos1 = pos;
          result0 = parse_time_hour();
          if (result0 !== null) {
            result1 = parse__();
            if (result1 !== null) {
              result2 = parse_am_pm();
              if (result2 !== null) {
                result0 = [result0, result1, result2];
              } else {
                result0 = null;
                pos = pos1;
              }
            } else {
              result0 = null;
              pos = pos1;
            }
          } else {
            result0 = null;
            pos = pos1;
          }
          if (result0 !== null) {
            result0 = (function(offset, t, offset) {
              t.setHours(t.getHours() + offset);
          
              return t;
            })(pos0, result0[0], result0[2]);
          }
          if (result0 === null) {
            pos = pos0;
          }
          if (result0 === null) {
            pos0 = pos;
            pos1 = pos;
            result0 = parse_time_hour_min();
            if (result0 !== null) {
              pos2 = pos;
              result1 = parse__();
              if (result1 !== null) {
                result2 = parse_am_pm();
                if (result2 !== null) {
                  result1 = [result1, result2];
                } else {
                  result1 = null;
                  pos = pos2;
                }
              } else {
                result1 = null;
                pos = pos2;
              }
              result1 = result1 !== null ? result1 : "";
              if (result1 !== null) {
                result0 = [result0, result1];
              } else {
                result0 = null;
                pos = pos1;
              }
            } else {
              result0 = null;
              pos = pos1;
            }
            if (result0 !== null) {
              result0 = (function(offset, t, tail) {
                if (typeof(tail) === 'object') {
                  t.setHours(t.getHours() + tail[1]);
                }
            
                return t;
              })(pos0, result0[0], result0[1]);
            }
            if (result0 === null) {
              pos = pos0;
            }
            if (result0 === null) {
              pos0 = pos;
              if (input.substr(pos, 4).toLowerCase() === "noon") {
                result0 = input.substr(pos, 4);
                pos += 4;
              } else {
                result0 = null;
                if (reportFailures === 0) {
                  matchFailed("\"NOON\"");
                }
              }
              if (result0 !== null) {
                result0 = (function(offset) {
                  var today = new Date();
              
                  today.setHours(12);
                  today.setMinutes(0);
                  today.setSeconds(0);
                  today.setMilliseconds(0);
              
                  return today;
                })(pos0);
              }
              if (result0 === null) {
                pos = pos0;
              }
              if (result0 === null) {
                pos0 = pos;
                if (input.substr(pos, 8).toLowerCase() === "midnight") {
                  result0 = input.substr(pos, 8);
                  pos += 8;
                } else {
                  result0 = null;
                  if (reportFailures === 0) {
                    matchFailed("\"MIDNIGHT\"");
                  }
                }
                if (result0 !== null) {
                  result0 = (function(offset) {
                    var today = new Date();
                
                    today.setHours(0);
                    today.setMinutes(0);
                    today.setSeconds(0);
                    today.setMilliseconds(0);
                
                    return today;
                  })(pos0);
                }
                if (result0 === null) {
                  pos = pos0;
                }
                if (result0 === null) {
                  pos0 = pos;
                  if (input.substr(pos, 7).toLowerCase() === "teatime") {
                    result0 = input.substr(pos, 7);
                    pos += 7;
                  } else {
                    result0 = null;
                    if (reportFailures === 0) {
                      matchFailed("\"TEATIME\"");
                    }
                  }
                  if (result0 !== null) {
                    result0 = (function(offset) {
                      var today = new Date();
                  
                      today.setHours(16);
                      today.setMinutes(0);
                      today.setSeconds(0);
                      today.setMilliseconds(0);
                  
                      return today;
                    })(pos0);
                  }
                  if (result0 === null) {
                    pos = pos0;
                  }
                }
              }
            }
          }
        }
        return result0;
      }
      
      function parse_hr24clock_hr_min() {
        var result0, result1, result2;
        var pos0, pos1, pos2;
        
        pos0 = pos;
        pos1 = pos;
        pos2 = pos;
        if (/^[0-9]/.test(input.charAt(pos))) {
          result0 = input.charAt(pos);
          pos++;
        } else {
          result0 = null;
          if (reportFailures === 0) {
            matchFailed("[0-9]");
          }
        }
        if (result0 !== null) {
          if (/^[0-9]/.test(input.charAt(pos))) {
            result1 = input.charAt(pos);
            pos++;
          } else {
            result1 = null;
            if (reportFailures === 0) {
              matchFailed("[0-9]");
            }
          }
          if (result1 !== null) {
            result0 = [result0, result1];
          } else {
            result0 = null;
            pos = pos2;
          }
        } else {
          result0 = null;
          pos = pos2;
        }
        if (result0 !== null) {
          pos2 = pos;
          if (/^[0-9]/.test(input.charAt(pos))) {
            result1 = input.charAt(pos);
            pos++;
          } else {
            result1 = null;
            if (reportFailures === 0) {
              matchFailed("[0-9]");
            }
          }
          if (result1 !== null) {
            if (/^[0-9]/.test(input.charAt(pos))) {
              result2 = input.charAt(pos);
              pos++;
            } else {
              result2 = null;
              if (reportFailures === 0) {
                matchFailed("[0-9]");
              }
            }
            if (result2 !== null) {
              result1 = [result1, result2];
            } else {
              result1 = null;
              pos = pos2;
            }
          } else {
            result1 = null;
            pos = pos2;
          }
          if (result1 !== null) {
            result0 = [result0, result1];
          } else {
            result0 = null;
            pos = pos1;
          }
        } else {
          result0 = null;
          pos = pos1;
        }
        if (result0 !== null) {
          result0 = (function(offset, hour, minute) {
            var today = new Date();
        
            today.setHours(parseInt(hour.join(''), 10));
            today.setMinutes(parseInt(minute.join(''), 10));
            today.setSeconds(0);
            today.setMilliseconds(0);
        
            return today;
          })(pos0, result0[0], result0[1]);
        }
        if (result0 === null) {
          pos = pos0;
        }
        return result0;
      }
      
      function parse_time_hour() {
        var result0;
        var pos0;
        
        pos0 = pos;
        result0 = parse_int1_2digit();
        if (result0 !== null) {
          result0 = (function(offset, hour) {
            var today = new Date();
        
            today.setHours(hour);
            today.setMinutes(0);
            today.setSeconds(0);
            today.setMilliseconds(0);
        
            return today;
          })(pos0, result0);
        }
        if (result0 === null) {
          pos = pos0;
        }
        return result0;
      }
      
      function parse_time_hour_min() {
        var result0, result1, result2, result3;
        var pos0, pos1, pos2;
        
        pos0 = pos;
        pos1 = pos;
        pos2 = pos;
        if (/^[012]/.test(input.charAt(pos))) {
          result0 = input.charAt(pos);
          pos++;
        } else {
          result0 = null;
          if (reportFailures === 0) {
            matchFailed("[012]");
          }
        }
        result0 = result0 !== null ? result0 : "";
        if (result0 !== null) {
          if (/^[0-9]/.test(input.charAt(pos))) {
            result1 = input.charAt(pos);
            pos++;
          } else {
            result1 = null;
            if (reportFailures === 0) {
              matchFailed("[0-9]");
            }
          }
          if (result1 !== null) {
            result0 = [result0, result1];
          } else {
            result0 = null;
            pos = pos2;
          }
        } else {
          result0 = null;
          pos = pos2;
        }
        if (result0 !== null) {
          if (/^[:'h,.]/.test(input.charAt(pos))) {
            result1 = input.charAt(pos);
            pos++;
          } else {
            result1 = null;
            if (reportFailures === 0) {
              matchFailed("[:'h,.]");
            }
          }
          if (result1 !== null) {
            pos2 = pos;
            if (/^[0-9]/.test(input.charAt(pos))) {
              result2 = input.charAt(pos);
              pos++;
            } else {
              result2 = null;
              if (reportFailures === 0) {
                matchFailed("[0-9]");
              }
            }
            if (result2 !== null) {
              if (/^[0-9]/.test(input.charAt(pos))) {
                result3 = input.charAt(pos);
                pos++;
              } else {
                result3 = null;
                if (reportFailures === 0) {
                  matchFailed("[0-9]");
                }
              }
              if (result3 !== null) {
                result2 = [result2, result3];
              } else {
                result2 = null;
                pos = pos2;
              }
            } else {
              result2 = null;
              pos = pos2;
            }
            if (result2 !== null) {
              result0 = [result0, result1, result2];
            } else {
              result0 = null;
              pos = pos1;
            }
          } else {
            result0 = null;
            pos = pos1;
          }
        } else {
          result0 = null;
          pos = pos1;
        }
        if (result0 !== null) {
          result0 = (function(offset, hour, minute) {
            var today = new Date();
        
            today.setHours(hour.join(''));
            today.setMinutes(minute.join(''));
            today.setSeconds(0);
            today.setMilliseconds(0);
        
            return today;
          })(pos0, result0[0], result0[2]);
        }
        if (result0 === null) {
          pos = pos0;
        }
        return result0;
      }
      
      function parse_am_pm() {
        var result0;
        var pos0;
        
        pos0 = pos;
        if (input.substr(pos, 2).toLowerCase() === "am") {
          result0 = input.substr(pos, 2);
          pos += 2;
        } else {
          result0 = null;
          if (reportFailures === 0) {
            matchFailed("\"AM\"");
          }
        }
        if (result0 !== null) {
          result0 = (function(offset) { return 12; })(pos0);
        }
        if (result0 === null) {
          pos = pos0;
        }
        if (result0 === null) {
          pos0 = pos;
          if (input.substr(pos, 2).toLowerCase() === "pm") {
            result0 = input.substr(pos, 2);
            pos += 2;
          } else {
            result0 = null;
            if (reportFailures === 0) {
              matchFailed("\"PM\"");
            }
          }
          if (result0 !== null) {
            result0 = (function(offset) { return 0; })(pos0);
          }
          if (result0 === null) {
            pos = pos0;
          }
        }
        return result0;
      }
      
      function parse_timezone_name() {
        var result0;
        
        if (input.substr(pos, 3).toLowerCase() === "utc") {
          result0 = input.substr(pos, 3);
          pos += 3;
        } else {
          result0 = null;
          if (reportFailures === 0) {
            matchFailed("\"UTC\"");
          }
        }
        return result0;
      }
      
      function parse_date() {
        var result0, result1, result2, result3, result4, result5;
        var pos0, pos1, pos2, pos3;
        
        pos0 = pos;
        pos1 = pos;
        result0 = parse_month_name();
        if (result0 !== null) {
          result1 = parse__();
          if (result1 !== null) {
            result2 = parse_int1_2digit();
            if (result2 !== null) {
              pos2 = pos;
              pos3 = pos;
              result3 = parse__();
              result3 = result3 !== null ? result3 : "";
              if (result3 !== null) {
                if (input.charCodeAt(pos) === 44) {
                  result4 = ",";
                  pos++;
                } else {
                  result4 = null;
                  if (reportFailures === 0) {
                    matchFailed("\",\"");
                  }
                }
                if (result4 !== null) {
                  result3 = [result3, result4];
                } else {
                  result3 = null;
                  pos = pos3;
                }
              } else {
                result3 = null;
                pos = pos3;
              }
              result3 = result3 !== null ? result3 : "";
              if (result3 !== null) {
                result4 = parse__();
                if (result4 !== null) {
                  result5 = parse_year_number();
                  if (result5 !== null) {
                    result3 = [result3, result4, result5];
                  } else {
                    result3 = null;
                    pos = pos2;
                  }
                } else {
                  result3 = null;
                  pos = pos2;
                }
              } else {
                result3 = null;
                pos = pos2;
              }
              result3 = result3 !== null ? result3 : "";
              if (result3 !== null) {
                result0 = [result0, result1, result2, result3];
              } else {
                result0 = null;
                pos = pos1;
              }
            } else {
              result0 = null;
              pos = pos1;
            }
          } else {
            result0 = null;
            pos = pos1;
          }
        } else {
          result0 = null;
          pos = pos1;
        }
        if (result0 !== null) {
          result0 = (function(offset, month, day, tail) {
            var now = null;
        
            if (typeof(tail) === 'object') {
              now = new Date(tail[2], month, day);
            }
            else {
              now = new Date(new Date().getFullYear(), month, day);
            }
        
            return now;
          })(pos0, result0[0], result0[2], result0[3]);
        }
        if (result0 === null) {
          pos = pos0;
        }
        if (result0 === null) {
          pos0 = pos;
          result0 = parse_day_of_week();
          if (result0 !== null) {
            result0 = (function(offset, day) {
              var now = new Date();
          
              now.setDate(now.getDate() + (day - now.getDay()));
          
              return now;
            })(pos0, result0);
          }
          if (result0 === null) {
            pos = pos0;
          }
          if (result0 === null) {
            pos0 = pos;
            if (input.substr(pos, 5).toLowerCase() === "today") {
              result0 = input.substr(pos, 5);
              pos += 5;
            } else {
              result0 = null;
              if (reportFailures === 0) {
                matchFailed("\"TODAY\"");
              }
            }
            if (result0 !== null) {
              result0 = (function(offset) {
                var now = new Date();
            
                now.setHours(0);
                now.setMinutes(0);
                now.setSeconds(0);
                now.setMilliseconds(0);
            
                return now;
              })(pos0);
            }
            if (result0 === null) {
              pos = pos0;
            }
            if (result0 === null) {
              pos0 = pos;
              if (input.substr(pos, 8).toLowerCase() === "tomorrow") {
                result0 = input.substr(pos, 8);
                pos += 8;
              } else {
                result0 = null;
                if (reportFailures === 0) {
                  matchFailed("\"TOMORROW\"");
                }
              }
              if (result0 !== null) {
                result0 = (function(offset) {
                  var now = new Date();
              
                  now.setDate(now.getDate() + 1);
              
                  return now;
                })(pos0);
              }
              if (result0 === null) {
                pos = pos0;
              }
              if (result0 === null) {
                pos0 = pos;
                if (input.substr(pos, 9).toLowerCase() === "yesterday") {
                  result0 = input.substr(pos, 9);
                  pos += 9;
                } else {
                  result0 = null;
                  if (reportFailures === 0) {
                    matchFailed("\"YESTERDAY\"");
                  }
                }
                if (result0 !== null) {
                  result0 = (function(offset) {
                    var now = new Date();
                
                    now.setDate(now.getDate() - 1);
                
                    return now;
                  })(pos0);
                }
                if (result0 === null) {
                  pos = pos0;
                }
                if (result0 === null) {
                  pos0 = pos;
                  pos1 = pos;
                  result0 = parse_year_number();
                  if (result0 !== null) {
                    if (/^[\-]/.test(input.charAt(pos))) {
                      result1 = input.charAt(pos);
                      pos++;
                    } else {
                      result1 = null;
                      if (reportFailures === 0) {
                        matchFailed("[\\-]");
                      }
                    }
                    if (result1 !== null) {
                      result2 = parse_int1_2digit();
                      if (result2 !== null) {
                        if (/^[\-]/.test(input.charAt(pos))) {
                          result3 = input.charAt(pos);
                          pos++;
                        } else {
                          result3 = null;
                          if (reportFailures === 0) {
                            matchFailed("[\\-]");
                          }
                        }
                        if (result3 !== null) {
                          result4 = parse_int1_2digit();
                          if (result4 !== null) {
                            result0 = [result0, result1, result2, result3, result4];
                          } else {
                            result0 = null;
                            pos = pos1;
                          }
                        } else {
                          result0 = null;
                          pos = pos1;
                        }
                      } else {
                        result0 = null;
                        pos = pos1;
                      }
                    } else {
                      result0 = null;
                      pos = pos1;
                    }
                  } else {
                    result0 = null;
                    pos = pos1;
                  }
                  if (result0 !== null) {
                    result0 = (function(offset, year, month, date) {
                      return new Date(year, month - 1, date);
                    })(pos0, result0[0], result0[2], result0[4]);
                  }
                  if (result0 === null) {
                    pos = pos0;
                  }
                  if (result0 === null) {
                    pos0 = pos;
                    pos1 = pos;
                    result0 = parse_int1_2digit();
                    if (result0 !== null) {
                      if (/^[.]/.test(input.charAt(pos))) {
                        result1 = input.charAt(pos);
                        pos++;
                      } else {
                        result1 = null;
                        if (reportFailures === 0) {
                          matchFailed("[.]");
                        }
                      }
                      if (result1 !== null) {
                        result2 = parse_int1_2digit();
                        if (result2 !== null) {
                          if (/^[.]/.test(input.charAt(pos))) {
                            result3 = input.charAt(pos);
                            pos++;
                          } else {
                            result3 = null;
                            if (reportFailures === 0) {
                              matchFailed("[.]");
                            }
                          }
                          if (result3 !== null) {
                            result4 = parse_year_number();
                            if (result4 !== null) {
                              result0 = [result0, result1, result2, result3, result4];
                            } else {
                              result0 = null;
                              pos = pos1;
                            }
                          } else {
                            result0 = null;
                            pos = pos1;
                          }
                        } else {
                          result0 = null;
                          pos = pos1;
                        }
                      } else {
                        result0 = null;
                        pos = pos1;
                      }
                    } else {
                      result0 = null;
                      pos = pos1;
                    }
                    if (result0 !== null) {
                      result0 = (function(offset, date, month, year) {
                        return new Date(year, month - 1, date);
                      })(pos0, result0[0], result0[2], result0[4]);
                    }
                    if (result0 === null) {
                      pos = pos0;
                    }
                    if (result0 === null) {
                      pos0 = pos;
                      pos1 = pos;
                      result0 = parse_int1_2digit();
                      if (result0 !== null) {
                        result1 = parse__();
                        if (result1 !== null) {
                          result2 = parse_month_name();
                          if (result2 !== null) {
                            pos2 = pos;
                            result3 = parse__();
                            if (result3 !== null) {
                              result4 = parse_year_number();
                              if (result4 !== null) {
                                result3 = [result3, result4];
                              } else {
                                result3 = null;
                                pos = pos2;
                              }
                            } else {
                              result3 = null;
                              pos = pos2;
                            }
                            result3 = result3 !== null ? result3 : "";
                            if (result3 !== null) {
                              result0 = [result0, result1, result2, result3];
                            } else {
                              result0 = null;
                              pos = pos1;
                            }
                          } else {
                            result0 = null;
                            pos = pos1;
                          }
                        } else {
                          result0 = null;
                          pos = pos1;
                        }
                      } else {
                        result0 = null;
                        pos = pos1;
                      }
                      if (result0 !== null) {
                        result0 = (function(offset, date, month, tail) {
                          var now = null;
                      
                          if (typeof(tail) === 'object') {
                            now = new Date(tail[1], month, date);
                          }
                          else {
                            now = new Date(new Date().getFullYear(), month, date);
                          }
                      
                          return now;
                        })(pos0, result0[0], result0[2], result0[3]);
                      }
                      if (result0 === null) {
                        pos = pos0;
                      }
                      if (result0 === null) {
                        pos0 = pos;
                        pos1 = pos;
                        result0 = parse_int1_2digit();
                        if (result0 !== null) {
                          if (input.charCodeAt(pos) === 47) {
                            result1 = "/";
                            pos++;
                          } else {
                            result1 = null;
                            if (reportFailures === 0) {
                              matchFailed("\"/\"");
                            }
                          }
                          if (result1 !== null) {
                            result2 = parse_int1_2digit();
                            if (result2 !== null) {
                              if (input.charCodeAt(pos) === 47) {
                                result3 = "/";
                                pos++;
                              } else {
                                result3 = null;
                                if (reportFailures === 0) {
                                  matchFailed("\"/\"");
                                }
                              }
                              if (result3 !== null) {
                                result4 = parse_year_number();
                                if (result4 !== null) {
                                  result0 = [result0, result1, result2, result3, result4];
                                } else {
                                  result0 = null;
                                  pos = pos1;
                                }
                              } else {
                                result0 = null;
                                pos = pos1;
                              }
                            } else {
                              result0 = null;
                              pos = pos1;
                            }
                          } else {
                            result0 = null;
                            pos = pos1;
                          }
                        } else {
                          result0 = null;
                          pos = pos1;
                        }
                        if (result0 !== null) {
                          result0 = (function(offset, month, date, year) {
                            return new Date(year, month - 1, date);
                          })(pos0, result0[0], result0[2], result0[4]);
                        }
                        if (result0 === null) {
                          pos = pos0;
                        }
                        if (result0 === null) {
                          result0 = parse_concatenated_date();
                          if (result0 === null) {
                            pos0 = pos;
                            pos1 = pos;
                            if (input.substr(pos, 4).toLowerCase() === "next") {
                              result0 = input.substr(pos, 4);
                              pos += 4;
                            } else {
                              result0 = null;
                              if (reportFailures === 0) {
                                matchFailed("\"NEXT\"");
                              }
                            }
                            if (result0 !== null) {
                              pos2 = pos;
                              result1 = parse__();
                              if (result1 !== null) {
                                result2 = parse_integer();
                                if (result2 !== null) {
                                  result1 = [result1, result2];
                                } else {
                                  result1 = null;
                                  pos = pos2;
                                }
                              } else {
                                result1 = null;
                                pos = pos2;
                              }
                              result1 = result1 !== null ? result1 : "";
                              if (result1 !== null) {
                                result2 = parse__();
                                if (result2 !== null) {
                                  result3 = parse_inc_dec_period();
                                  if (result3 !== null) {
                                    result0 = [result0, result1, result2, result3];
                                  } else {
                                    result0 = null;
                                    pos = pos1;
                                  }
                                } else {
                                  result0 = null;
                                  pos = pos1;
                                }
                              } else {
                                result0 = null;
                                pos = pos1;
                              }
                            } else {
                              result0 = null;
                              pos = pos1;
                            }
                            if (result0 !== null) {
                              result0 = (function(offset, c, amount) {
                                var now = new Date();
                                var count = 1;
                            
                                if (typeof(c) === 'object') {
                                  count = c[1];
                                }
                            
                                now.setFullYear(now.getFullYear() + (amount.y * count));
                                now.setMonth(now.getMonth() + (amount.m * count));
                                now.setDate(now.getDate() + (amount.d * count));
                                now.setHours(now.getHours() + (amount.h * count));
                                now.setMinutes(now.getMinutes() + (amount.i * count));
                            
                                return now;
                              })(pos0, result0[1], result0[3]);
                            }
                            if (result0 === null) {
                              pos = pos0;
                            }
                            if (result0 === null) {
                              pos0 = pos;
                              pos1 = pos;
                              if (input.substr(pos, 4).toLowerCase() === "next") {
                                result0 = input.substr(pos, 4);
                                pos += 4;
                              } else {
                                result0 = null;
                                if (reportFailures === 0) {
                                  matchFailed("\"NEXT\"");
                                }
                              }
                              if (result0 !== null) {
                                result1 = parse__();
                                if (result1 !== null) {
                                  result2 = parse_day_of_week();
                                  if (result2 !== null) {
                                    result0 = [result0, result1, result2];
                                  } else {
                                    result0 = null;
                                    pos = pos1;
                                  }
                                } else {
                                  result0 = null;
                                  pos = pos1;
                                }
                              } else {
                                result0 = null;
                                pos = pos1;
                              }
                              if (result0 !== null) {
                                result0 = (function(offset, day) {
                                  var now = new Date();
                              
                                  now.setDate(now.getDate() + (day - now.getDay()) + 7);
                              
                                  return now;
                                })(pos0, result0[2]);
                              }
                              if (result0 === null) {
                                pos = pos0;
                              }
                              if (result0 === null) {
                                pos0 = pos;
                                pos1 = pos;
                                if (input.substr(pos, 4).toLowerCase() === "last") {
                                  result0 = input.substr(pos, 4);
                                  pos += 4;
                                } else {
                                  result0 = null;
                                  if (reportFailures === 0) {
                                    matchFailed("\"LAST\"");
                                  }
                                }
                                if (result0 !== null) {
                                  pos2 = pos;
                                  result1 = parse__();
                                  if (result1 !== null) {
                                    result2 = parse_integer();
                                    if (result2 !== null) {
                                      result1 = [result1, result2];
                                    } else {
                                      result1 = null;
                                      pos = pos2;
                                    }
                                  } else {
                                    result1 = null;
                                    pos = pos2;
                                  }
                                  result1 = result1 !== null ? result1 : "";
                                  if (result1 !== null) {
                                    result2 = parse__();
                                    if (result2 !== null) {
                                      result3 = parse_inc_dec_period();
                                      if (result3 !== null) {
                                        result0 = [result0, result1, result2, result3];
                                      } else {
                                        result0 = null;
                                        pos = pos1;
                                      }
                                    } else {
                                      result0 = null;
                                      pos = pos1;
                                    }
                                  } else {
                                    result0 = null;
                                    pos = pos1;
                                  }
                                } else {
                                  result0 = null;
                                  pos = pos1;
                                }
                                if (result0 !== null) {
                                  result0 = (function(offset, c, amount) {
                                    var now = new Date();
                                    var count = 1;
                                
                                    if (typeof(c) === 'object') {
                                      count = c[1];
                                    }
                                
                                    now.setFullYear(now.getFullYear() + (amount.y * -count));
                                    now.setMonth(now.getMonth() + (amount.m * -count));
                                    now.setDate(now.getDate() + (amount.d * -count));
                                    now.setHours(now.getHours() + (amount.h * -count));
                                    now.setMinutes(now.getMinutes() + (amount.i * -count));
                                
                                    return now;
                                  })(pos0, result0[1], result0[3]);
                                }
                                if (result0 === null) {
                                  pos = pos0;
                                }
                                if (result0 === null) {
                                  pos0 = pos;
                                  pos1 = pos;
                                  if (input.substr(pos, 4).toLowerCase() === "last") {
                                    result0 = input.substr(pos, 4);
                                    pos += 4;
                                  } else {
                                    result0 = null;
                                    if (reportFailures === 0) {
                                      matchFailed("\"LAST\"");
                                    }
                                  }
                                  if (result0 !== null) {
                                    result1 = parse__();
                                    if (result1 !== null) {
                                      result2 = parse_day_of_week();
                                      if (result2 !== null) {
                                        result0 = [result0, result1, result2];
                                      } else {
                                        result0 = null;
                                        pos = pos1;
                                      }
                                    } else {
                                      result0 = null;
                                      pos = pos1;
                                    }
                                  } else {
                                    result0 = null;
                                    pos = pos1;
                                  }
                                  if (result0 !== null) {
                                    result0 = (function(offset, day) {
                                      var now = new Date();
                                  
                                      if (now.getDay() === day) {
                                        now.setDate(now.getDate() - 7);
                                      }
                                  
                                      now.setDate(now.getDate() + (day - now.getDay()));
                                  
                                      return now;
                                    })(pos0, result0[2]);
                                  }
                                  if (result0 === null) {
                                    pos = pos0;
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        return result0;
      }
      
      function parse_concatenated_date() {
        var result0;
        var pos0;
        
        pos0 = pos;
        result0 = parse_str5_8digit();
        if (result0 !== null) {
          result0 = (function(offset, digits) {
            var year = 0;
            var month = 0;
            var day = 0;
        
            if (digits.length === 5 || digits.length === 6) { /* YearMonth */
              year = parseInt(digits.slice(0, 4), 10);
              month = parseInt(digits.slice(4), 10) - 1;
            }
            else if (digits.length === 7 || digits.length === 8) { /* YearMonthDay */
              year = parseInt(digits.slice(0, 4), 10);
              month = parseInt(digits.slice(4, 6), 10) - 1;
              day = parseInt(digits.slice(6), 10);
            }
        
            return new Date(year, month, day);
          })(pos0, result0);
        }
        if (result0 === null) {
          pos = pos0;
        }
        return result0;
      }
      
      function parse_month_name() {
        var result0, result1;
        var pos0, pos1;
        
        pos0 = pos;
        pos1 = pos;
        if (input.substr(pos, 3).toLowerCase() === "jan") {
          result0 = input.substr(pos, 3);
          pos += 3;
        } else {
          result0 = null;
          if (reportFailures === 0) {
            matchFailed("\"JAN\"");
          }
        }
        if (result0 !== null) {
          if (input.substr(pos, 4).toLowerCase() === "uary") {
            result1 = input.substr(pos, 4);
            pos += 4;
          } else {
            result1 = null;
            if (reportFailures === 0) {
              matchFailed("\"UARY\"");
            }
          }
          result1 = result1 !== null ? result1 : "";
          if (result1 !== null) {
            result0 = [result0, result1];
          } else {
            result0 = null;
            pos = pos1;
          }
        } else {
          result0 = null;
          pos = pos1;
        }
        if (result0 !== null) {
          result0 = (function(offset) { return 0; })(pos0);
        }
        if (result0 === null) {
          pos = pos0;
        }
        if (result0 === null) {
          pos0 = pos;
          pos1 = pos;
          if (input.substr(pos, 3).toLowerCase() === "feb") {
            result0 = input.substr(pos, 3);
            pos += 3;
          } else {
            result0 = null;
            if (reportFailures === 0) {
              matchFailed("\"FEB\"");
            }
          }
          if (result0 !== null) {
            if (input.substr(pos, 5).toLowerCase() === "ruary") {
              result1 = input.substr(pos, 5);
              pos += 5;
            } else {
              result1 = null;
              if (reportFailures === 0) {
                matchFailed("\"RUARY\"");
              }
            }
            result1 = result1 !== null ? result1 : "";
            if (result1 !== null) {
              result0 = [result0, result1];
            } else {
              result0 = null;
              pos = pos1;
            }
          } else {
            result0 = null;
            pos = pos1;
          }
          if (result0 !== null) {
            result0 = (function(offset) { return 1; })(pos0);
          }
          if (result0 === null) {
            pos = pos0;
          }
          if (result0 === null) {
            pos0 = pos;
            pos1 = pos;
            if (input.substr(pos, 3).toLowerCase() === "mar") {
              result0 = input.substr(pos, 3);
              pos += 3;
            } else {
              result0 = null;
              if (reportFailures === 0) {
                matchFailed("\"MAR\"");
              }
            }
            if (result0 !== null) {
              if (input.substr(pos, 2).toLowerCase() === "ch") {
                result1 = input.substr(pos, 2);
                pos += 2;
              } else {
                result1 = null;
                if (reportFailures === 0) {
                  matchFailed("\"CH\"");
                }
              }
              result1 = result1 !== null ? result1 : "";
              if (result1 !== null) {
                result0 = [result0, result1];
              } else {
                result0 = null;
                pos = pos1;
              }
            } else {
              result0 = null;
              pos = pos1;
            }
            if (result0 !== null) {
              result0 = (function(offset) { return 2; })(pos0);
            }
            if (result0 === null) {
              pos = pos0;
            }
            if (result0 === null) {
              pos0 = pos;
              pos1 = pos;
              if (input.substr(pos, 3).toLowerCase() === "apr") {
                result0 = input.substr(pos, 3);
                pos += 3;
              } else {
                result0 = null;
                if (reportFailures === 0) {
                  matchFailed("\"APR\"");
                }
              }
              if (result0 !== null) {
                if (input.substr(pos, 2).toLowerCase() === "il") {
                  result1 = input.substr(pos, 2);
                  pos += 2;
                } else {
                  result1 = null;
                  if (reportFailures === 0) {
                    matchFailed("\"IL\"");
                  }
                }
                result1 = result1 !== null ? result1 : "";
                if (result1 !== null) {
                  result0 = [result0, result1];
                } else {
                  result0 = null;
                  pos = pos1;
                }
              } else {
                result0 = null;
                pos = pos1;
              }
              if (result0 !== null) {
                result0 = (function(offset) { return 3; })(pos0);
              }
              if (result0 === null) {
                pos = pos0;
              }
              if (result0 === null) {
                pos0 = pos;
                if (input.substr(pos, 3).toLowerCase() === "may") {
                  result0 = input.substr(pos, 3);
                  pos += 3;
                } else {
                  result0 = null;
                  if (reportFailures === 0) {
                    matchFailed("\"MAY\"");
                  }
                }
                if (result0 !== null) {
                  result0 = (function(offset) { return 4; })(pos0);
                }
                if (result0 === null) {
                  pos = pos0;
                }
                if (result0 === null) {
                  pos0 = pos;
                  pos1 = pos;
                  if (input.substr(pos, 3).toLowerCase() === "jun") {
                    result0 = input.substr(pos, 3);
                    pos += 3;
                  } else {
                    result0 = null;
                    if (reportFailures === 0) {
                      matchFailed("\"JUN\"");
                    }
                  }
                  if (result0 !== null) {
                    if (input.substr(pos, 1).toLowerCase() === "e") {
                      result1 = input.substr(pos, 1);
                      pos++;
                    } else {
                      result1 = null;
                      if (reportFailures === 0) {
                        matchFailed("\"E\"");
                      }
                    }
                    result1 = result1 !== null ? result1 : "";
                    if (result1 !== null) {
                      result0 = [result0, result1];
                    } else {
                      result0 = null;
                      pos = pos1;
                    }
                  } else {
                    result0 = null;
                    pos = pos1;
                  }
                  if (result0 !== null) {
                    result0 = (function(offset) { return 5; })(pos0);
                  }
                  if (result0 === null) {
                    pos = pos0;
                  }
                  if (result0 === null) {
                    pos0 = pos;
                    pos1 = pos;
                    if (input.substr(pos, 3).toLowerCase() === "jul") {
                      result0 = input.substr(pos, 3);
                      pos += 3;
                    } else {
                      result0 = null;
                      if (reportFailures === 0) {
                        matchFailed("\"JUL\"");
                      }
                    }
                    if (result0 !== null) {
                      if (input.substr(pos, 1).toLowerCase() === "y") {
                        result1 = input.substr(pos, 1);
                        pos++;
                      } else {
                        result1 = null;
                        if (reportFailures === 0) {
                          matchFailed("\"Y\"");
                        }
                      }
                      result1 = result1 !== null ? result1 : "";
                      if (result1 !== null) {
                        result0 = [result0, result1];
                      } else {
                        result0 = null;
                        pos = pos1;
                      }
                    } else {
                      result0 = null;
                      pos = pos1;
                    }
                    if (result0 !== null) {
                      result0 = (function(offset) { return 6; })(pos0);
                    }
                    if (result0 === null) {
                      pos = pos0;
                    }
                    if (result0 === null) {
                      pos0 = pos;
                      pos1 = pos;
                      if (input.substr(pos, 3).toLowerCase() === "aug") {
                        result0 = input.substr(pos, 3);
                        pos += 3;
                      } else {
                        result0 = null;
                        if (reportFailures === 0) {
                          matchFailed("\"AUG\"");
                        }
                      }
                      if (result0 !== null) {
                        if (input.substr(pos, 3).toLowerCase() === "ust") {
                          result1 = input.substr(pos, 3);
                          pos += 3;
                        } else {
                          result1 = null;
                          if (reportFailures === 0) {
                            matchFailed("\"UST\"");
                          }
                        }
                        result1 = result1 !== null ? result1 : "";
                        if (result1 !== null) {
                          result0 = [result0, result1];
                        } else {
                          result0 = null;
                          pos = pos1;
                        }
                      } else {
                        result0 = null;
                        pos = pos1;
                      }
                      if (result0 !== null) {
                        result0 = (function(offset) { return 7; })(pos0);
                      }
                      if (result0 === null) {
                        pos = pos0;
                      }
                      if (result0 === null) {
                        pos0 = pos;
                        pos1 = pos;
                        if (input.substr(pos, 3).toLowerCase() === "sep") {
                          result0 = input.substr(pos, 3);
                          pos += 3;
                        } else {
                          result0 = null;
                          if (reportFailures === 0) {
                            matchFailed("\"SEP\"");
                          }
                        }
                        if (result0 !== null) {
                          if (input.substr(pos, 6).toLowerCase() === "tember") {
                            result1 = input.substr(pos, 6);
                            pos += 6;
                          } else {
                            result1 = null;
                            if (reportFailures === 0) {
                              matchFailed("\"TEMBER\"");
                            }
                          }
                          result1 = result1 !== null ? result1 : "";
                          if (result1 !== null) {
                            result0 = [result0, result1];
                          } else {
                            result0 = null;
                            pos = pos1;
                          }
                        } else {
                          result0 = null;
                          pos = pos1;
                        }
                        if (result0 !== null) {
                          result0 = (function(offset) { return 8; })(pos0);
                        }
                        if (result0 === null) {
                          pos = pos0;
                        }
                        if (result0 === null) {
                          pos0 = pos;
                          pos1 = pos;
                          if (input.substr(pos, 3).toLowerCase() === "oct") {
                            result0 = input.substr(pos, 3);
                            pos += 3;
                          } else {
                            result0 = null;
                            if (reportFailures === 0) {
                              matchFailed("\"OCT\"");
                            }
                          }
                          if (result0 !== null) {
                            if (input.substr(pos, 4).toLowerCase() === "ober") {
                              result1 = input.substr(pos, 4);
                              pos += 4;
                            } else {
                              result1 = null;
                              if (reportFailures === 0) {
                                matchFailed("\"OBER\"");
                              }
                            }
                            result1 = result1 !== null ? result1 : "";
                            if (result1 !== null) {
                              result0 = [result0, result1];
                            } else {
                              result0 = null;
                              pos = pos1;
                            }
                          } else {
                            result0 = null;
                            pos = pos1;
                          }
                          if (result0 !== null) {
                            result0 = (function(offset) { return 9; })(pos0);
                          }
                          if (result0 === null) {
                            pos = pos0;
                          }
                          if (result0 === null) {
                            pos0 = pos;
                            pos1 = pos;
                            if (input.substr(pos, 3).toLowerCase() === "nov") {
                              result0 = input.substr(pos, 3);
                              pos += 3;
                            } else {
                              result0 = null;
                              if (reportFailures === 0) {
                                matchFailed("\"NOV\"");
                              }
                            }
                            if (result0 !== null) {
                              if (input.substr(pos, 5).toLowerCase() === "ember") {
                                result1 = input.substr(pos, 5);
                                pos += 5;
                              } else {
                                result1 = null;
                                if (reportFailures === 0) {
                                  matchFailed("\"EMBER\"");
                                }
                              }
                              result1 = result1 !== null ? result1 : "";
                              if (result1 !== null) {
                                result0 = [result0, result1];
                              } else {
                                result0 = null;
                                pos = pos1;
                              }
                            } else {
                              result0 = null;
                              pos = pos1;
                            }
                            if (result0 !== null) {
                              result0 = (function(offset) { return 10; })(pos0);
                            }
                            if (result0 === null) {
                              pos = pos0;
                            }
                            if (result0 === null) {
                              pos0 = pos;
                              pos1 = pos;
                              if (input.substr(pos, 3).toLowerCase() === "dec") {
                                result0 = input.substr(pos, 3);
                                pos += 3;
                              } else {
                                result0 = null;
                                if (reportFailures === 0) {
                                  matchFailed("\"DEC\"");
                                }
                              }
                              if (result0 !== null) {
                                if (input.substr(pos, 5).toLowerCase() === "ember") {
                                  result1 = input.substr(pos, 5);
                                  pos += 5;
                                } else {
                                  result1 = null;
                                  if (reportFailures === 0) {
                                    matchFailed("\"EMBER\"");
                                  }
                                }
                                result1 = result1 !== null ? result1 : "";
                                if (result1 !== null) {
                                  result0 = [result0, result1];
                                } else {
                                  result0 = null;
                                  pos = pos1;
                                }
                              } else {
                                result0 = null;
                                pos = pos1;
                              }
                              if (result0 !== null) {
                                result0 = (function(offset) { return 11; })(pos0);
                              }
                              if (result0 === null) {
                                pos = pos0;
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        return result0;
      }
      
      function parse_year_number() {
        var result0;
        var pos0;
        
        pos0 = pos;
        result0 = parse_int2_or_4digit();
        if (result0 !== null) {
          result0 = (function(offset, year) {
            if (year < 100) {
              return year + 2000;
            }
        
            return year;
          })(pos0, result0);
        }
        if (result0 === null) {
          pos = pos0;
        }
        return result0;
      }
      
      function parse_day_of_week() {
        var result0, result1;
        var pos0, pos1;
        
        pos0 = pos;
        pos1 = pos;
        if (input.substr(pos, 3).toLowerCase() === "sun") {
          result0 = input.substr(pos, 3);
          pos += 3;
        } else {
          result0 = null;
          if (reportFailures === 0) {
            matchFailed("\"SUN\"");
          }
        }
        if (result0 !== null) {
          if (input.substr(pos, 3).toLowerCase() === "day") {
            result1 = input.substr(pos, 3);
            pos += 3;
          } else {
            result1 = null;
            if (reportFailures === 0) {
              matchFailed("\"DAY\"");
            }
          }
          result1 = result1 !== null ? result1 : "";
          if (result1 !== null) {
            result0 = [result0, result1];
          } else {
            result0 = null;
            pos = pos1;
          }
        } else {
          result0 = null;
          pos = pos1;
        }
        if (result0 !== null) {
          result0 = (function(offset) { return 0; })(pos0);
        }
        if (result0 === null) {
          pos = pos0;
        }
        if (result0 === null) {
          pos0 = pos;
          pos1 = pos;
          if (input.substr(pos, 3).toLowerCase() === "mon") {
            result0 = input.substr(pos, 3);
            pos += 3;
          } else {
            result0 = null;
            if (reportFailures === 0) {
              matchFailed("\"MON\"");
            }
          }
          if (result0 !== null) {
            if (input.substr(pos, 3).toLowerCase() === "day") {
              result1 = input.substr(pos, 3);
              pos += 3;
            } else {
              result1 = null;
              if (reportFailures === 0) {
                matchFailed("\"DAY\"");
              }
            }
            result1 = result1 !== null ? result1 : "";
            if (result1 !== null) {
              result0 = [result0, result1];
            } else {
              result0 = null;
              pos = pos1;
            }
          } else {
            result0 = null;
            pos = pos1;
          }
          if (result0 !== null) {
            result0 = (function(offset) { return 1; })(pos0);
          }
          if (result0 === null) {
            pos = pos0;
          }
          if (result0 === null) {
            pos0 = pos;
            pos1 = pos;
            if (input.substr(pos, 3).toLowerCase() === "tue") {
              result0 = input.substr(pos, 3);
              pos += 3;
            } else {
              result0 = null;
              if (reportFailures === 0) {
                matchFailed("\"TUE\"");
              }
            }
            if (result0 !== null) {
              if (input.substr(pos, 4).toLowerCase() === "sday") {
                result1 = input.substr(pos, 4);
                pos += 4;
              } else {
                result1 = null;
                if (reportFailures === 0) {
                  matchFailed("\"SDAY\"");
                }
              }
              result1 = result1 !== null ? result1 : "";
              if (result1 !== null) {
                result0 = [result0, result1];
              } else {
                result0 = null;
                pos = pos1;
              }
            } else {
              result0 = null;
              pos = pos1;
            }
            if (result0 !== null) {
              result0 = (function(offset) { return 2; })(pos0);
            }
            if (result0 === null) {
              pos = pos0;
            }
            if (result0 === null) {
              pos0 = pos;
              pos1 = pos;
              if (input.substr(pos, 3).toLowerCase() === "wed") {
                result0 = input.substr(pos, 3);
                pos += 3;
              } else {
                result0 = null;
                if (reportFailures === 0) {
                  matchFailed("\"WED\"");
                }
              }
              if (result0 !== null) {
                if (input.substr(pos, 6).toLowerCase() === "nesday") {
                  result1 = input.substr(pos, 6);
                  pos += 6;
                } else {
                  result1 = null;
                  if (reportFailures === 0) {
                    matchFailed("\"NESDAY\"");
                  }
                }
                result1 = result1 !== null ? result1 : "";
                if (result1 !== null) {
                  result0 = [result0, result1];
                } else {
                  result0 = null;
                  pos = pos1;
                }
              } else {
                result0 = null;
                pos = pos1;
              }
              if (result0 !== null) {
                result0 = (function(offset) { return 3; })(pos0);
              }
              if (result0 === null) {
                pos = pos0;
              }
              if (result0 === null) {
                pos0 = pos;
                pos1 = pos;
                if (input.substr(pos, 3).toLowerCase() === "thu") {
                  result0 = input.substr(pos, 3);
                  pos += 3;
                } else {
                  result0 = null;
                  if (reportFailures === 0) {
                    matchFailed("\"THU\"");
                  }
                }
                if (result0 !== null) {
                  if (input.substr(pos, 5).toLowerCase() === "rsday") {
                    result1 = input.substr(pos, 5);
                    pos += 5;
                  } else {
                    result1 = null;
                    if (reportFailures === 0) {
                      matchFailed("\"RSDAY\"");
                    }
                  }
                  result1 = result1 !== null ? result1 : "";
                  if (result1 !== null) {
                    result0 = [result0, result1];
                  } else {
                    result0 = null;
                    pos = pos1;
                  }
                } else {
                  result0 = null;
                  pos = pos1;
                }
                if (result0 !== null) {
                  result0 = (function(offset) { return 4; })(pos0);
                }
                if (result0 === null) {
                  pos = pos0;
                }
                if (result0 === null) {
                  pos0 = pos;
                  pos1 = pos;
                  if (input.substr(pos, 3).toLowerCase() === "fri") {
                    result0 = input.substr(pos, 3);
                    pos += 3;
                  } else {
                    result0 = null;
                    if (reportFailures === 0) {
                      matchFailed("\"FRI\"");
                    }
                  }
                  if (result0 !== null) {
                    if (input.substr(pos, 3).toLowerCase() === "day") {
                      result1 = input.substr(pos, 3);
                      pos += 3;
                    } else {
                      result1 = null;
                      if (reportFailures === 0) {
                        matchFailed("\"DAY\"");
                      }
                    }
                    result1 = result1 !== null ? result1 : "";
                    if (result1 !== null) {
                      result0 = [result0, result1];
                    } else {
                      result0 = null;
                      pos = pos1;
                    }
                  } else {
                    result0 = null;
                    pos = pos1;
                  }
                  if (result0 !== null) {
                    result0 = (function(offset) { return 5; })(pos0);
                  }
                  if (result0 === null) {
                    pos = pos0;
                  }
                  if (result0 === null) {
                    pos0 = pos;
                    pos1 = pos;
                    if (input.substr(pos, 3).toLowerCase() === "sat") {
                      result0 = input.substr(pos, 3);
                      pos += 3;
                    } else {
                      result0 = null;
                      if (reportFailures === 0) {
                        matchFailed("\"SAT\"");
                      }
                    }
                    if (result0 !== null) {
                      if (input.substr(pos, 5).toLowerCase() === "urday") {
                        result1 = input.substr(pos, 5);
                        pos += 5;
                      } else {
                        result1 = null;
                        if (reportFailures === 0) {
                          matchFailed("\"URDAY\"");
                        }
                      }
                      result1 = result1 !== null ? result1 : "";
                      if (result1 !== null) {
                        result0 = [result0, result1];
                      } else {
                        result0 = null;
                        pos = pos1;
                      }
                    } else {
                      result0 = null;
                      pos = pos1;
                    }
                    if (result0 !== null) {
                      result0 = (function(offset) { return 6; })(pos0);
                    }
                    if (result0 === null) {
                      pos = pos0;
                    }
                  }
                }
              }
            }
          }
        }
        return result0;
      }
      
      function parse_inc_or_dec() {
        var result0;
        
        result0 = parse_increment();
        if (result0 === null) {
          result0 = parse_decrement();
        }
        return result0;
      }
      
      function parse_increment() {
        var result0, result1, result2, result3, result4;
        var pos0, pos1;
        
        pos0 = pos;
        pos1 = pos;
        if (input.charCodeAt(pos) === 43) {
          result0 = "+";
          pos++;
        } else {
          result0 = null;
          if (reportFailures === 0) {
            matchFailed("\"+\"");
          }
        }
        if (result0 !== null) {
          result1 = parse__();
          if (result1 !== null) {
            result2 = parse_integer();
            if (result2 !== null) {
              result3 = parse__();
              if (result3 !== null) {
                result4 = parse_inc_dec_period();
                if (result4 !== null) {
                  result0 = [result0, result1, result2, result3, result4];
                } else {
                  result0 = null;
                  pos = pos1;
                }
              } else {
                result0 = null;
                pos = pos1;
              }
            } else {
              result0 = null;
              pos = pos1;
            }
          } else {
            result0 = null;
            pos = pos1;
          }
        } else {
          result0 = null;
          pos = pos1;
        }
        if (result0 !== null) {
          result0 = (function(offset, count, amount) {
            return { 'count': count, 'amount': amount };
          })(pos0, result0[2], result0[4]);
        }
        if (result0 === null) {
          pos = pos0;
        }
        return result0;
      }
      
      function parse_decrement() {
        var result0, result1, result2, result3, result4;
        var pos0, pos1;
        
        pos0 = pos;
        pos1 = pos;
        if (input.charCodeAt(pos) === 45) {
          result0 = "-";
          pos++;
        } else {
          result0 = null;
          if (reportFailures === 0) {
            matchFailed("\"-\"");
          }
        }
        if (result0 !== null) {
          result1 = parse__();
          if (result1 !== null) {
            result2 = parse_integer();
            if (result2 !== null) {
              result3 = parse__();
              if (result3 !== null) {
                result4 = parse_inc_dec_period();
                if (result4 !== null) {
                  result0 = [result0, result1, result2, result3, result4];
                } else {
                  result0 = null;
                  pos = pos1;
                }
              } else {
                result0 = null;
                pos = pos1;
              }
            } else {
              result0 = null;
              pos = pos1;
            }
          } else {
            result0 = null;
            pos = pos1;
          }
        } else {
          result0 = null;
          pos = pos1;
        }
        if (result0 !== null) {
          result0 = (function(offset, count, amount) {
            return { 'count': count * -1, 'amount': amount };
          })(pos0, result0[2], result0[4]);
        }
        if (result0 === null) {
          pos = pos0;
        }
        return result0;
      }
      
      function parse_inc_dec_period() {
        var result0, result1;
        var pos0, pos1;
        
        pos0 = pos;
        pos1 = pos;
        if (input.substr(pos, 6).toLowerCase() === "minute") {
          result0 = input.substr(pos, 6);
          pos += 6;
        } else {
          result0 = null;
          if (reportFailures === 0) {
            matchFailed("\"MINUTE\"");
          }
        }
        if (result0 !== null) {
          if (input.substr(pos, 1).toLowerCase() === "s") {
            result1 = input.substr(pos, 1);
            pos++;
          } else {
            result1 = null;
            if (reportFailures === 0) {
              matchFailed("\"S\"");
            }
          }
          result1 = result1 !== null ? result1 : "";
          if (result1 !== null) {
            result0 = [result0, result1];
          } else {
            result0 = null;
            pos = pos1;
          }
        } else {
          result0 = null;
          pos = pos1;
        }
        if (result0 !== null) {
          result0 = (function(offset) { return {'y': 0, 'm': 0, 'd': 0, 'h': 0, 'i': 1}; })(pos0);
        }
        if (result0 === null) {
          pos = pos0;
        }
        if (result0 === null) {
          pos0 = pos;
          pos1 = pos;
          if (input.substr(pos, 4).toLowerCase() === "hour") {
            result0 = input.substr(pos, 4);
            pos += 4;
          } else {
            result0 = null;
            if (reportFailures === 0) {
              matchFailed("\"HOUR\"");
            }
          }
          if (result0 !== null) {
            if (input.substr(pos, 1).toLowerCase() === "s") {
              result1 = input.substr(pos, 1);
              pos++;
            } else {
              result1 = null;
              if (reportFailures === 0) {
                matchFailed("\"S\"");
              }
            }
            result1 = result1 !== null ? result1 : "";
            if (result1 !== null) {
              result0 = [result0, result1];
            } else {
              result0 = null;
              pos = pos1;
            }
          } else {
            result0 = null;
            pos = pos1;
          }
          if (result0 !== null) {
            result0 = (function(offset) { return {'y': 0, 'm': 0, 'd': 0, 'h': 1, 'i': 0}; })(pos0);
          }
          if (result0 === null) {
            pos = pos0;
          }
          if (result0 === null) {
            pos0 = pos;
            pos1 = pos;
            if (input.substr(pos, 3).toLowerCase() === "day") {
              result0 = input.substr(pos, 3);
              pos += 3;
            } else {
              result0 = null;
              if (reportFailures === 0) {
                matchFailed("\"DAY\"");
              }
            }
            if (result0 !== null) {
              if (input.substr(pos, 1).toLowerCase() === "s") {
                result1 = input.substr(pos, 1);
                pos++;
              } else {
                result1 = null;
                if (reportFailures === 0) {
                  matchFailed("\"S\"");
                }
              }
              result1 = result1 !== null ? result1 : "";
              if (result1 !== null) {
                result0 = [result0, result1];
              } else {
                result0 = null;
                pos = pos1;
              }
            } else {
              result0 = null;
              pos = pos1;
            }
            if (result0 !== null) {
              result0 = (function(offset) { return {'y': 0, 'm': 0, 'd': 1, 'h': 0, 'i': 0}; })(pos0);
            }
            if (result0 === null) {
              pos = pos0;
            }
            if (result0 === null) {
              pos0 = pos;
              pos1 = pos;
              if (input.substr(pos, 4).toLowerCase() === "week") {
                result0 = input.substr(pos, 4);
                pos += 4;
              } else {
                result0 = null;
                if (reportFailures === 0) {
                  matchFailed("\"WEEK\"");
                }
              }
              if (result0 !== null) {
                if (input.substr(pos, 1).toLowerCase() === "s") {
                  result1 = input.substr(pos, 1);
                  pos++;
                } else {
                  result1 = null;
                  if (reportFailures === 0) {
                    matchFailed("\"S\"");
                  }
                }
                result1 = result1 !== null ? result1 : "";
                if (result1 !== null) {
                  result0 = [result0, result1];
                } else {
                  result0 = null;
                  pos = pos1;
                }
              } else {
                result0 = null;
                pos = pos1;
              }
              if (result0 !== null) {
                result0 = (function(offset) { return {'y': 0, 'm': 0, 'd': 7, 'h': 0, 'i': 0}; })(pos0);
              }
              if (result0 === null) {
                pos = pos0;
              }
              if (result0 === null) {
                pos0 = pos;
                pos1 = pos;
                if (input.substr(pos, 5).toLowerCase() === "month") {
                  result0 = input.substr(pos, 5);
                  pos += 5;
                } else {
                  result0 = null;
                  if (reportFailures === 0) {
                    matchFailed("\"MONTH\"");
                  }
                }
                if (result0 !== null) {
                  if (input.substr(pos, 1).toLowerCase() === "s") {
                    result1 = input.substr(pos, 1);
                    pos++;
                  } else {
                    result1 = null;
                    if (reportFailures === 0) {
                      matchFailed("\"S\"");
                    }
                  }
                  result1 = result1 !== null ? result1 : "";
                  if (result1 !== null) {
                    result0 = [result0, result1];
                  } else {
                    result0 = null;
                    pos = pos1;
                  }
                } else {
                  result0 = null;
                  pos = pos1;
                }
                if (result0 !== null) {
                  result0 = (function(offset) { return {'y': 0, 'm': 1, 'd': 0, 'h': 0, 'i': 0}; })(pos0);
                }
                if (result0 === null) {
                  pos = pos0;
                }
                if (result0 === null) {
                  pos0 = pos;
                  pos1 = pos;
                  if (input.substr(pos, 4).toLowerCase() === "year") {
                    result0 = input.substr(pos, 4);
                    pos += 4;
                  } else {
                    result0 = null;
                    if (reportFailures === 0) {
                      matchFailed("\"YEAR\"");
                    }
                  }
                  if (result0 !== null) {
                    if (input.substr(pos, 1).toLowerCase() === "s") {
                      result1 = input.substr(pos, 1);
                      pos++;
                    } else {
                      result1 = null;
                      if (reportFailures === 0) {
                        matchFailed("\"S\"");
                      }
                    }
                    result1 = result1 !== null ? result1 : "";
                    if (result1 !== null) {
                      result0 = [result0, result1];
                    } else {
                      result0 = null;
                      pos = pos1;
                    }
                  } else {
                    result0 = null;
                    pos = pos1;
                  }
                  if (result0 !== null) {
                    result0 = (function(offset) { return {'y': 1, 'm': 0, 'd': 0, 'h': 0, 'i': 0}; })(pos0);
                  }
                  if (result0 === null) {
                    pos = pos0;
                  }
                }
              }
            }
          }
        }
        return result0;
      }
      
      function parse_int1_2digit() {
        var result0, result1;
        var pos0, pos1;
        
        pos0 = pos;
        pos1 = pos;
        if (/^[0-9]/.test(input.charAt(pos))) {
          result0 = input.charAt(pos);
          pos++;
        } else {
          result0 = null;
          if (reportFailures === 0) {
            matchFailed("[0-9]");
          }
        }
        if (result0 !== null) {
          if (/^[0-9]/.test(input.charAt(pos))) {
            result1 = input.charAt(pos);
            pos++;
          } else {
            result1 = null;
            if (reportFailures === 0) {
              matchFailed("[0-9]");
            }
          }
          result1 = result1 !== null ? result1 : "";
          if (result1 !== null) {
            result0 = [result0, result1];
          } else {
            result0 = null;
            pos = pos1;
          }
        } else {
          result0 = null;
          pos = pos1;
        }
        if (result0 !== null) {
          result0 = (function(offset, digits) {
            return parseInt(digits.join(''), 10);
          })(pos0, result0);
        }
        if (result0 === null) {
          pos = pos0;
        }
        return result0;
      }
      
      function parse_int2_or_4digit() {
        var result0, result1, result2, result3;
        var pos0, pos1, pos2;
        
        pos0 = pos;
        pos1 = pos;
        if (/^[0-9]/.test(input.charAt(pos))) {
          result0 = input.charAt(pos);
          pos++;
        } else {
          result0 = null;
          if (reportFailures === 0) {
            matchFailed("[0-9]");
          }
        }
        if (result0 !== null) {
          if (/^[0-9]/.test(input.charAt(pos))) {
            result1 = input.charAt(pos);
            pos++;
          } else {
            result1 = null;
            if (reportFailures === 0) {
              matchFailed("[0-9]");
            }
          }
          if (result1 !== null) {
            pos2 = pos;
            if (/^[0-9]/.test(input.charAt(pos))) {
              result2 = input.charAt(pos);
              pos++;
            } else {
              result2 = null;
              if (reportFailures === 0) {
                matchFailed("[0-9]");
              }
            }
            if (result2 !== null) {
              if (/^[0-9]/.test(input.charAt(pos))) {
                result3 = input.charAt(pos);
                pos++;
              } else {
                result3 = null;
                if (reportFailures === 0) {
                  matchFailed("[0-9]");
                }
              }
              if (result3 !== null) {
                result2 = [result2, result3];
              } else {
                result2 = null;
                pos = pos2;
              }
            } else {
              result2 = null;
              pos = pos2;
            }
            result2 = result2 !== null ? result2 : "";
            if (result2 !== null) {
              result0 = [result0, result1, result2];
            } else {
              result0 = null;
              pos = pos1;
            }
          } else {
            result0 = null;
            pos = pos1;
          }
        } else {
          result0 = null;
          pos = pos1;
        }
        if (result0 !== null) {
          result0 = (function(offset, digits) {
            var value = digits.slice(0, 2).join('');
        
            if (typeof(digits[2]) === 'object') {
              value += digits[2].join('');
            }
        
            return parseInt(value, 10);
          })(pos0, result0);
        }
        if (result0 === null) {
          pos = pos0;
        }
        return result0;
      }
      
      function parse_str5_8digit() {
        var result0, result1, result2, result3, result4, result5, result6, result7;
        var pos0, pos1, pos2;
        
        pos0 = pos;
        pos1 = pos;
        if (/^[0-9]/.test(input.charAt(pos))) {
          result0 = input.charAt(pos);
          pos++;
        } else {
          result0 = null;
          if (reportFailures === 0) {
            matchFailed("[0-9]");
          }
        }
        if (result0 !== null) {
          if (/^[0-9]/.test(input.charAt(pos))) {
            result1 = input.charAt(pos);
            pos++;
          } else {
            result1 = null;
            if (reportFailures === 0) {
              matchFailed("[0-9]");
            }
          }
          if (result1 !== null) {
            if (/^[0-9]/.test(input.charAt(pos))) {
              result2 = input.charAt(pos);
              pos++;
            } else {
              result2 = null;
              if (reportFailures === 0) {
                matchFailed("[0-9]");
              }
            }
            if (result2 !== null) {
              if (/^[0-9]/.test(input.charAt(pos))) {
                result3 = input.charAt(pos);
                pos++;
              } else {
                result3 = null;
                if (reportFailures === 0) {
                  matchFailed("[0-9]");
                }
              }
              if (result3 !== null) {
                if (/^[0-9]/.test(input.charAt(pos))) {
                  result4 = input.charAt(pos);
                  pos++;
                } else {
                  result4 = null;
                  if (reportFailures === 0) {
                    matchFailed("[0-9]");
                  }
                }
                if (result4 !== null) {
                  pos2 = pos;
                  if (/^[0-9]/.test(input.charAt(pos))) {
                    result5 = input.charAt(pos);
                    pos++;
                  } else {
                    result5 = null;
                    if (reportFailures === 0) {
                      matchFailed("[0-9]");
                    }
                  }
                  if (result5 !== null) {
                    if (/^[0-9]/.test(input.charAt(pos))) {
                      result6 = input.charAt(pos);
                      pos++;
                    } else {
                      result6 = null;
                      if (reportFailures === 0) {
                        matchFailed("[0-9]");
                      }
                    }
                    if (result6 !== null) {
                      if (/^[0-9]/.test(input.charAt(pos))) {
                        result7 = input.charAt(pos);
                        pos++;
                      } else {
                        result7 = null;
                        if (reportFailures === 0) {
                          matchFailed("[0-9]");
                        }
                      }
                      if (result7 !== null) {
                        result5 = [result5, result6, result7];
                      } else {
                        result5 = null;
                        pos = pos2;
                      }
                    } else {
                      result5 = null;
                      pos = pos2;
                    }
                  } else {
                    result5 = null;
                    pos = pos2;
                  }
                  if (result5 === null) {
                    pos2 = pos;
                    if (/^[0-9]/.test(input.charAt(pos))) {
                      result5 = input.charAt(pos);
                      pos++;
                    } else {
                      result5 = null;
                      if (reportFailures === 0) {
                        matchFailed("[0-9]");
                      }
                    }
                    if (result5 !== null) {
                      if (/^[0-9]/.test(input.charAt(pos))) {
                        result6 = input.charAt(pos);
                        pos++;
                      } else {
                        result6 = null;
                        if (reportFailures === 0) {
                          matchFailed("[0-9]");
                        }
                      }
                      if (result6 !== null) {
                        result5 = [result5, result6];
                      } else {
                        result5 = null;
                        pos = pos2;
                      }
                    } else {
                      result5 = null;
                      pos = pos2;
                    }
                    if (result5 === null) {
                      if (/^[0-9]/.test(input.charAt(pos))) {
                        result5 = input.charAt(pos);
                        pos++;
                      } else {
                        result5 = null;
                        if (reportFailures === 0) {
                          matchFailed("[0-9]");
                        }
                      }
                    }
                  }
                  result5 = result5 !== null ? result5 : "";
                  if (result5 !== null) {
                    result0 = [result0, result1, result2, result3, result4, result5];
                  } else {
                    result0 = null;
                    pos = pos1;
                  }
                } else {
                  result0 = null;
                  pos = pos1;
                }
              } else {
                result0 = null;
                pos = pos1;
              }
            } else {
              result0 = null;
              pos = pos1;
            }
          } else {
            result0 = null;
            pos = pos1;
          }
        } else {
          result0 = null;
          pos = pos1;
        }
        if (result0 !== null) {
          result0 = (function(offset, digits) {
            var value = digits.slice(0, 5).join('');
        
            if (typeof(digits[5]) === 'object') {
              value += digits[5].join('');
            }
            else {
              value += digits[5];
            }
        
            return value;
          })(pos0, result0);
        }
        if (result0 === null) {
          pos = pos0;
        }
        return result0;
      }
      
      function parse_integer() {
        var result0, result1;
        var pos0;
        
        pos0 = pos;
        if (/^[0-9]/.test(input.charAt(pos))) {
          result1 = input.charAt(pos);
          pos++;
        } else {
          result1 = null;
          if (reportFailures === 0) {
            matchFailed("[0-9]");
          }
        }
        if (result1 !== null) {
          result0 = [];
          while (result1 !== null) {
            result0.push(result1);
            if (/^[0-9]/.test(input.charAt(pos))) {
              result1 = input.charAt(pos);
              pos++;
            } else {
              result1 = null;
              if (reportFailures === 0) {
                matchFailed("[0-9]");
              }
            }
          }
        } else {
          result0 = null;
        }
        if (result0 !== null) {
          result0 = (function(offset, digits) {
            return parseInt(digits.join(''), 10);
          })(pos0, result0);
        }
        if (result0 === null) {
          pos = pos0;
        }
        return result0;
      }
      
      function parse__() {
        var result0, result1;
        
        result0 = [];
        if (/^[\t\n\r _]/.test(input.charAt(pos))) {
          result1 = input.charAt(pos);
          pos++;
        } else {
          result1 = null;
          if (reportFailures === 0) {
            matchFailed("[\\t\\n\\r _]");
          }
        }
        while (result1 !== null) {
          result0.push(result1);
          if (/^[\t\n\r _]/.test(input.charAt(pos))) {
            result1 = input.charAt(pos);
            pos++;
          } else {
            result1 = null;
            if (reportFailures === 0) {
              matchFailed("[\\t\\n\\r _]");
            }
          }
        }
        return result0;
      }
      
      
      function cleanupExpected(expected) {
        expected.sort();
        
        var lastExpected = null;
        var cleanExpected = [];
        for (var i = 0; i < expected.length; i++) {
          if (expected[i] !== lastExpected) {
            cleanExpected.push(expected[i]);
            lastExpected = expected[i];
          }
        }
        return cleanExpected;
      }
      
      function computeErrorPosition() {
        /*
         * The first idea was to use |String.split| to break the input up to the
         * error position along newlines and derive the line and column from
         * there. However IE's |split| implementation is so broken that it was
         * enough to prevent it.
         */
        
        var line = 1;
        var column = 1;
        var seenCR = false;
        
        for (var i = 0; i < Math.max(pos, rightmostFailuresPos); i++) {
          var ch = input.charAt(i);
          if (ch === "\n") {
            if (!seenCR) { line++; }
            column = 1;
            seenCR = false;
          } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
            line++;
            column = 1;
            seenCR = true;
          } else {
            column++;
            seenCR = false;
          }
        }
        
        return { line: line, column: column };
      }
      
      
      var result = parseFunctions[startRule]();
      
      /*
       * The parser is now in one of the following three states:
       *
       * 1. The parser successfully parsed the whole input.
       *
       *    - |result !== null|
       *    - |pos === input.length|
       *    - |rightmostFailuresExpected| may or may not contain something
       *
       * 2. The parser successfully parsed only a part of the input.
       *
       *    - |result !== null|
       *    - |pos < input.length|
       *    - |rightmostFailuresExpected| may or may not contain something
       *
       * 3. The parser did not successfully parse any part of the input.
       *
       *   - |result === null|
       *   - |pos === 0|
       *   - |rightmostFailuresExpected| contains at least one failure
       *
       * All code following this comment (including called functions) must
       * handle these states.
       */
      if (result === null || pos !== input.length) {
        var offset = Math.max(pos, rightmostFailuresPos);
        var found = offset < input.length ? input.charAt(offset) : null;
        var errorPosition = computeErrorPosition();
        
        throw new this.SyntaxError(
          cleanupExpected(rightmostFailuresExpected),
          found,
          offset,
          errorPosition.line,
          errorPosition.column
        );
      }
      
      return result;
    },
    
    /* Returns the parser source code. */
    toSource: function() { return this._source; }
  };
  
  /* Thrown when a parser encounters a syntax error. */
  
  result.SyntaxError = function(expected, found, offset, line, column) {
    function buildMessage(expected, found) {
      var expectedHumanized, foundHumanized;
      
      switch (expected.length) {
        case 0:
          expectedHumanized = "end of input";
          break;
        case 1:
          expectedHumanized = expected[0];
          break;
        default:
          expectedHumanized = expected.slice(0, expected.length - 1).join(", ")
            + " or "
            + expected[expected.length - 1];
      }
      
      foundHumanized = found ? quote(found) : "end of input";
      
      return "Expected " + expectedHumanized + " but " + foundHumanized + " found.";
    }
    
    this.name = "SyntaxError";
    this.expected = expected;
    this.found = found;
    this.message = buildMessage(expected, found);
    this.offset = offset;
    this.line = line;
    this.column = column;
  };
  
  result.SyntaxError.prototype = Error.prototype;
  
  return result;
})();



//////////////////
// WEBPACK FOOTER
// ./~/timespec/timespec.js
// module id = 14
// module chunks = 0